/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateFeedItemDto } from '../models/CreateFeedItemDto';
import type { DeletedResponse } from '../models/DeletedResponse';
import type { FeedItemResponse } from '../models/FeedItemResponse';
import type { UpdateFeedItemDto } from '../models/UpdateFeedItemDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FeedService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get active feed items
     * Returns active feed items for the authenticated user. Optionally accepts lat/lng to scope results to the user commune. Falls back to global-only items if coordinates are missing or no commune matches.
     * @returns FeedItemResponse Active feed items returned successfully.
     * @throws ApiError
     */
    public feedControllerGetActiveFeed({
        lat,
        lng,
    }: {
        /**
         * Latitude of the user location
         */
        lat?: number,
        /**
         * Longitude of the user location
         */
        lng?: number,
    } = {}): CancelablePromise<Array<FeedItemResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/feed',
            query: {
                'lat': lat,
                'lng': lng,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Create a feed item (admin)
     * Creates a new feed item. Admin only.
     * @returns FeedItemResponse Feed item created successfully.
     * @throws ApiError
     */
    public feedControllerCreate({
        requestBody,
    }: {
        requestBody: CreateFeedItemDto,
    }): CancelablePromise<FeedItemResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/feed',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
            },
        });
    }
    /**
     * List all feed items (admin)
     * Returns a paginated list of all feed items with optional filters. Admin only.
     * @returns any Feed items returned successfully.
     * @throws ApiError
     */
    public feedControllerFindAll({
        page = 1,
        limit = 20,
        sortBy,
        sortOrder = 'desc',
        type,
        isActive,
        search,
    }: {
        /**
         * Page number (starts from 1)
         */
        page?: number,
        /**
         * Number of items per page (max 200)
         */
        limit?: number,
        /**
         * Field to sort by (alphanumeric, dots, and underscores only). Must be validated against allowed fields in the consuming service.
         */
        sortBy?: string,
        /**
         * Sort order
         */
        sortOrder?: 'asc' | 'desc',
        /**
         * Filter by feed item type
         */
        type?: 'ADVICE' | 'PROMO' | 'INFO' | 'ALERT',
        /**
         * Filter by active status
         */
        isActive?: boolean,
        /**
         * Search by title
         */
        search?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/feed/admin',
            query: {
                'page': page,
                'limit': limit,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
                'type': type,
                'isActive': isActive,
                'search': search,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
            },
        });
    }
    /**
     * Update a feed item (admin)
     * Updates an existing feed item. Admin only.
     * @returns FeedItemResponse Feed item updated successfully.
     * @throws ApiError
     */
    public feedControllerUpdate({
        id,
        requestBody,
    }: {
        /**
         * Feed item unique identifier
         */
        id: string,
        requestBody: UpdateFeedItemDto,
    }): CancelablePromise<FeedItemResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/feed/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                404: `Feed item not found.`,
            },
        });
    }
    /**
     * Delete a feed item (admin)
     * Deletes a feed item. Admin only.
     * @returns DeletedResponse Feed item deleted successfully.
     * @throws ApiError
     */
    public feedControllerRemove({
        id,
    }: {
        /**
         * Feed item unique identifier
         */
        id: string,
    }): CancelablePromise<DeletedResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/feed/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. ADMIN role required.`,
                404: `Feed item not found.`,
            },
        });
    }
}
